let defaultTxt =
  "whitespace-nowrap font-medium tracking-wider rounded-full py-3 px-10 ";

export const buttonYellow =
  defaultTxt + "bg-yellow border border-yellow hover:bg-trp";

export const buttonRed = defaultTxt + " bg-red border border-red hover:bg-trp";

export const buttonGreen =
  defaultTxt + " bg-green border border-green hover:bg-trp";

export const buttonPurple =
  defaultTxt + " bg-prp border border-prp hover:bg-trp";

export const buttonChartreuse =
  defaultTxt + " bg-chartreuse border border-chartreuse hover:bg-trp";

export const buttonCyan =
  defaultTxt + " bg-cyan border border-cyan hover:bg-trp";

export const buttonMagenta =
  defaultTxt + " bg-magenta border border-magenta hover:bg-trp";

export const buttonBlue =
  defaultTxt + " bg-blue border border-blue hover:bg-trp";

export const buttonOrange =
  defaultTxt + " bg-orange border border-orange hover:bg-trp";

export const buttonClasses = [
  buttonYellow,
  buttonPurple,
  buttonRed,
  buttonOrange,
  buttonGreen,
  buttonMagenta,
  buttonChartreuse,
  buttonRed,
  buttonBlue,
  buttonCyan,
];
